const ROUTES = {
    HOME: '/',
    NOT_FOUND: null,
};

export default ROUTES;